import get from 'lodash/get'
import fromPairs from 'lodash/fromPairs'

const parse = (queryString = null) => {
	let query = (null !== queryString ? queryString : window.location.search)
	if (!query) {
		return false
	}

	if ('?' === query.substr(0, 1)) {
		query = query.substring(1)
	}

	const params = new URLSearchParams(query)

	return fromPairs(Array.from(params.entries()))
}

const addArg = (key, value, queryString = null) => {
	let query = (null !== queryString ? queryString : window.location.search)
	query = query ? ('?' === query.substr(0, 1) ? query.substring(1) : query) : '?'

	const params = new URLSearchParams(query)
	params.set(key, value)

	return params.toString()
}

const getArg = (key, queryString = null) => get(parse(queryString), key)

export default {
	parse,
	add : addArg,
	get : getArg,
}
